import { AgentBookingModel } from '@/__generated';
import { AppUrls } from '@/urls';
import React from 'react';
import { Link } from 'react-router-dom';
import ContactDetail from './ContactDetail';
import ReadOnlyPassengerDetail from './ReadOnlyPassengerDetail';
import SamePaxAndNextBookingButton from './SamePaxAndNextBookingButton';
import { BookingSource } from '@/constants';

type Props = {
  booking: AgentBookingModel;
};

export default function BookingCompletedDetail({ booking }: Props) {
  const showAddSamePaxBtn = React.useMemo(() => {
    return booking.roomSearchInfos?.length && booking.refNumber && booking.source !== BookingSource.ForAgent;
  }, [booking]);
  return (
    <>
      <ContactDetail contactDetail={booking.bookingContactDetail} />
      <ReadOnlyPassengerDetail passenger={booking.bookingLeadPaxDetail} />
      <div className="row x-gap-10 mt-20 y-gap-10">
        {showAddSamePaxBtn ? (
          <div className="col-12 col-md-auto">
            <SamePaxAndNextBookingButton bookingRefNumber={booking.refNumber || ''} rooms={booking.roomSearchInfos || []} />
          </div>
        ) : null}

        <div className="col-12 col-md-auto">
          <Link to={AppUrls.__createBookingDetailUrl(booking.id || '')} className="button -dark-1 bg-green-2 text-white px-20 py-15">
            Booking summary
            <i className="icon-airplane ml-15" />
          </Link>
        </div>
      </div>
    </>
  );
}
